<template lang="html">
    <ul class="main-menu__submenu">
        <li class="main-menu__item has-droprdown has-arrow">
            <a v-bind:class="{'active': $route.meta.report}" @click.prevent.stop="$root.toggleMenu($event)">
                <md-icon class="arrow-icon-right">keyboard_arrow_right</md-icon>
                <md-icon class="arrow-icon-down">keyboard_arrow_down</md-icon>
                <md-icon>list</md-icon>
                <span>Отчеты</span>
            </a>
            <ul class="main-menu__submenu">
                <li class="main-menu__item">
                    <router-link v-bind:to="{ name: 'ForwardingReport' }"   v-bind:class="(($route.name == 'ForwardingReport')   ? $router.options.settingsLinkActiveClass : '' )">Отчет по экспедированию</router-link>
                    <router-link v-bind:to="{ name: 'NoForwardingReport' }" v-bind:class="(($route.name == 'NoForwardingReport') ? $router.options.settingsLinkActiveClass : '' )">Отчет по не экспедированным грузам</router-link>
                    <router-link v-bind:to="{ name: 'TransferReport' }"     v-bind:class="(($route.name == 'TransferReport')     ? $router.options.settingsLinkActiveClass : '' )">Отчет по перевозкам</router-link>
                    <router-link v-bind:to="{ name: 'RoutelistReport' }"    v-bind:class="(($route.name == 'RoutelistReport')    ? $router.options.settingsLinkActiveClass : '' )">Отчет по маршрутным листам</router-link>
                    <router-link v-bind:to="{ name: 'ServicesReport' }"     v-bind:class="(($route.name == 'ServicesReport')     ? $router.options.settingsLinkActiveClass : '' )">Отчет по услугам</router-link>
                    <!--
                        <router-link v-bind:to="{ name: 'ManagerTrackReport' }"      v-bind:class="(($route.name == 'ManagerTrackReport')      ? $router.options.settingsLinkActiveClass : '' )">Путевой отчет для менеджера</router-link>
                        <router-link v-bind:to="{ name: 'RealisationErrorsReport' }" v-bind:class="(($route.name == 'RealisationErrorsReport') ? $router.options.settingsLinkActiveClass : '' )">Ошибки в реализациях</router-link>
                        <router-link v-bind:to="{ name: 'MissingDocumentsReport' }"  v-bind:class="(($route.name == 'MissingDocumentsReport')  ? $router.options.settingsLinkActiveClass : '' )">Отсутствующие документы</router-link>
                        <router-link v-bind:to="{ name: 'PaymentReport' }"           v-bind:class="(($route.name == 'PaymentReport')           ? $router.options.settingsLinkActiveClass : '' )">Отчет по оплате</router-link>
                        <router-link v-bind:to="{ name: 'DispatcherReport' }"        v-bind:class="(($route.name == 'DispatcherReport')        ? $router.options.settingsLinkActiveClass : '' )">Отчет для диспетчера</router-link>
                    -->
                </li>
            </ul>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'reports-main-menu',
    sort: 6,
    module: 'reports',
    data() {
        return  {
            module: 'reports'
        }
    }
}
</script>


// WEBPACK FOOTER //
// MainMenu.vue?88c0f2b0